(function() {
    var formEl = document.querySelector('[js-klaviyo-lazy-form]');
    if (!formEl) return;
    var loaded = false;
    function loadKlaviyo() {
        if (loaded) return;
        loaded = true;
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=V9rGqY';
        document.head.appendChild(script);
    }
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) { 
        if (entry.isIntersecting) {
            loadKlaviyo(); 
            observer.disconnect();  
        }  
        });
    }, { rootMargin: '200px' });
    observer.observe(formEl);
})();

window.addEventListener('scroll', function() { 
    scrolled();
}, { passive: true }); 

document.addEventListener("wishlist-hero-wishlist-sdk-ready", async function(e) {
    var wishlist_item_count = window.WishListHero_SDK.GetWishListItemsCount();
    if (wishlist_item_count > 0) {
        document.querySelector(".wishlist-hero-items-count").style.display = "block";
    } else {
        document.querySelector(".wishlist-hero-items-count").style.display = "none";
    }
    document.querySelector(".wishlist-hero-items-count").innerHTML = wishlist_item_count;
    setTimeout(function() {
        var wishlist_icon = document.querySelectorAll('.size_popup-parent .wishlist-hero-custom-button.wishlisthero-floating button');
        wishlist_icon.forEach(function(wishlist) {
            wishlist.innerHTML = '<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.4578 2.50292C18.9691 2.02645 18.3889 1.64848 17.7503 1.39061C17.1117 1.13273 16.4272 1 15.7359 1C15.0446 1 14.3601 1.13273 13.7215 1.39061C13.0829 1.64848 12.5026 2.02645 12.0139 2.50292L10.9997 3.4913L9.98554 2.50292C8.99842 1.54094 7.6596 1.0005 6.26361 1.0005C4.86761 1.0005 3.52879 1.54094 2.54168 2.50292C1.55456 3.46491 1 4.76964 1 6.1301C1 7.49055 1.55456 8.79529 2.54168 9.75727L3.55588 10.7457L10.9997 18L18.4436 10.7457L19.4578 9.75727C19.9467 9.28102 20.3346 8.71557 20.5992 8.0932C20.8638 7.47084 21 6.80377 21 6.1301C21 5.45642 20.8638 4.78935 20.5992 4.16699C20.3346 3.54463 19.9467 2.97917 19.4578 2.50292Z" stroke="#313131" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        });
        var wishlist_icon3 = document.querySelectorAll('.cart-item .wishlist-hero-custom-button.wishlisthero-floating button');
        wishlist_icon3.forEach(function(wishlist) {
            wishlist.innerHTML = '<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.4578 2.50292C18.9691 2.02645 18.3889 1.64848 17.7503 1.39061C17.1117 1.13273 16.4272 1 15.7359 1C15.0446 1 14.3601 1.13273 13.7215 1.39061C13.0829 1.64848 12.5026 2.02645 12.0139 2.50292L10.9997 3.4913L9.98554 2.50292C8.99842 1.54094 7.6596 1.0005 6.26361 1.0005C4.86761 1.0005 3.52879 1.54094 2.54168 2.50292C1.55456 3.46491 1 4.76964 1 6.1301C1 7.49055 1.55456 8.79529 2.54168 9.75727L3.55588 10.7457L10.9997 18L18.4436 10.7457L19.4578 9.75727C19.9467 9.28102 20.3346 8.71557 20.5992 8.0932C20.8638 7.47084 21 6.80377 21 6.1301C21 5.45642 20.8638 4.78935 20.5992 4.16699C20.3346 3.54463 19.9467 2.97917 19.4578 2.50292Z" stroke="#313131" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        });
        var wishlist_icon2 = document.querySelectorAll('.product-title-wishlist-wrapp .wishlist-hero-custom-button.wishlisthero-floating button');
        wishlist_icon2.forEach(function(wishlist) {
            wishlist.innerHTML = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.9952 3.36109C24.3599 2.63237 23.6056 2.0543 22.7754 1.6599C21.9451 1.2655 21.0553 1.0625 20.1566 1.0625C19.258 1.0625 18.3681 1.2655 17.5379 1.6599C16.7077 2.0543 15.9534 2.63237 15.3181 3.36109L13.9997 4.87273L12.6812 3.36109C11.3979 1.88982 9.65749 1.06326 7.84269 1.06326C6.0279 1.06326 4.28743 1.88982 3.00418 3.36109C1.72092 4.83236 1 6.82784 1 8.90853C1 10.9892 1.72092 12.9847 3.00418 14.456L4.32264 15.9676L13.9997 27.0625L23.6767 15.9676L24.9952 14.456C25.6308 13.7276 26.1349 12.8628 26.4789 11.9109C26.8229 10.9591 27 9.93885 27 8.90853C27 7.87821 26.8229 6.85798 26.4789 5.90613C26.1349 4.95428 25.6308 4.08947 24.9952 3.36109Z" stroke="#313131" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        }); 
        var wishlist_icon4 = document.querySelectorAll('.searchWishList .wishlist-hero-custom-button.wishlisthero-floating button');
        wishlist_icon4.forEach(function(wishlist) {
            wishlist.innerHTML = '<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.4578 2.50292C18.9691 2.02645 18.3889 1.64848 17.7503 1.39061C17.1117 1.13273 16.4272 1 15.7359 1C15.0446 1 14.3601 1.13273 13.7215 1.39061C13.0829 1.64848 12.5026 2.02645 12.0139 2.50292L10.9997 3.4913L9.98554 2.50292C8.99842 1.54094 7.6596 1.0005 6.26361 1.0005C4.86761 1.0005 3.52879 1.54094 2.54168 2.50292C1.55456 3.46491 1 4.76964 1 6.1301C1 7.49055 1.55456 8.79529 2.54168 9.75727L3.55588 10.7457L10.9997 18L18.4436 10.7457L19.4578 9.75727C19.9467 9.28102 20.3346 8.71557 20.5992 8.0932C20.8638 7.47084 21 6.80377 21 6.1301C21 5.45642 20.8638 4.78935 20.5992 4.16699C20.3346 3.54463 19.9467 2.97917 19.4578 2.50292Z" stroke="#313131" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        });
        var wishlist_icon5 = document.querySelectorAll('.shopwishListbtn .wishlist-hero-custom-button.wishlisthero-floating button');
        wishlist_icon5.forEach(function(wishlist) {
            wishlist.innerHTML = '<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.4578 2.50292C18.9691 2.02645 18.3889 1.64848 17.7503 1.39061C17.1117 1.13273 16.4272 1 15.7359 1C15.0446 1 14.3601 1.13273 13.7215 1.39061C13.0829 1.64848 12.5026 2.02645 12.0139 2.50292L10.9997 3.4913L9.98554 2.50292C8.99842 1.54094 7.6596 1.0005 6.26361 1.0005C4.86761 1.0005 3.52879 1.54094 2.54168 2.50292C1.55456 3.46491 1 4.76964 1 6.1301C1 7.49055 1.55456 8.79529 2.54168 9.75727L3.55588 10.7457L10.9997 18L18.4436 10.7457L19.4578 9.75727C19.9467 9.28102 20.3346 8.71557 20.5992 8.0932C20.8638 7.47084 21 6.80377 21 6.1301C21 5.45642 20.8638 4.78935 20.5992 4.16699C20.3346 3.54463 19.9467 2.97917 19.4578 2.50292Z" stroke="#313131" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        });
    }, 4000); 
});
   
function scrolled() {
    if (window.scrollY > 0) {
        document.body.classList.add("announcement-hide");
    } else {
        document.body.classList.remove("announcement-hide");
    }
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

document.addEventListener("click", function(event) {
    var target = event.target;
    if (target && target.closest(".recent_serches_wrapper .rpeated_recentsearches")) {
        var dataValue = target.getAttribute("data-value");
        var searchInput = document.querySelector("input#Search-In-Template");
        var searchInput2 = document.querySelector("input#Search-In-Modal");
        if (searchInput) {
            searchInput.value = dataValue;
            var searchButton = document.querySelector("button.search__button.field__button");
            if (searchButton) {
                searchButton.click();
            }
        }
        if (searchInput2) {
            searchInput2.value = dataValue;
            var searchButton2 = document.querySelector("button.search__button.field__button");
            if (searchButton2) {
                searchButton2.click(); 
            }
        }
    } 
}); 

document.querySelectorAll('.navList').forEach((elm)=>{
  elm.addEventListener('mouseenter', (target)=>{
    if( target.target.querySelector('.mega-menu') ){
      target.preventDefault();
      target.currentTarget.closest('.navList').classList.add('active');
      target.target.querySelector('.mega-menu').setAttribute('open','open');
      document.body.classList.add("NavActive"); 
      if(target.target.querySelector('.sidebar_images_wrapp')){
        if(!target.target.querySelector('.sidebar_images_wrapp').classList.contains("swiper-container-initialized")){
            new Swiper(target.target.querySelector('.sidebar_images_wrapp'), {
                loop: false, slidesPerView: 2, spaceBetween: 10, autoplay: { delay: 5000 },
                breakpoints: { 1920: {slidesPerView: 2,spaceBetween: 10},1028: {slidesPerView: 2,spaceBetween: 10},480: {slidesPerView: 1,spaceBetween: 10} }
            });          
        } 
      }
    }
  });
  elm.addEventListener('mouseleave', (target)=>{
    if( target.target.querySelector('.mega-menu') ){
      target.currentTarget.closest('.navList').classList.remove('active');
      target.target.querySelector('.mega-menu').removeAttribute('open');
      document.body.classList.remove("NavActive");
    }
  });  
});

document.addEventListener('DOMContentLoaded', function() {

    // ---- FIX: this getComputedStyle loop is expensive (forces layout).
    // Deferred until the browser is idle / after LCP has painted, instead
    // of running synchronously on every page load.
    function checkSizePopups() {
        document.querySelectorAll(".size_popup-parent").forEach(function(element) {
            var inputLabelWrappers = element.querySelectorAll(".MainVariants .input-label-wrapper");
            var visibleElementsCount = 0;
            inputLabelWrappers.forEach(function(inputLabelWrapper) {
                var style = window.getComputedStyle(inputLabelWrapper);
                if (style.display !== 'none') {
                    visibleElementsCount++;
                }
            });
            if (visibleElementsCount === 0) {
                var popupElement = element.querySelector(".product_listing_sizes-popup");
                if (popupElement) {
                    popupElement.style.display = "none";
                } 
            }
        });
    }
    if ('requestIdleCallback' in window) {
        requestIdleCallback(checkSizePopups, { timeout: 2000 }); 
    } else {
        setTimeout(checkSizePopups, 500); 
    }  

    scrolled();

    var getslider = document.querySelector('.HiddenSlider');
    var cartList = document.querySelector('.CartProduct_List');
    var getdata = document.querySelector('.MainEmpty_Bag');
    var emptyBagPro = document.querySelector('.EmptyBag_pro');
    var cartSubmitBtn = document.querySelector('#checkout');
    if (getslider && cartList) {
        cartList.innerHTML = '<div class="Outer_ProductLists">' + getslider.innerHTML + '</div>';
    }
    if (getdata && emptyBagPro) {
        emptyBagPro.innerHTML = '<div class="MainEmpty_Bag">' + getdata.innerHTML + '</div>';
    }
    function isIE() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        const trident = ua.indexOf('Trident/');
        return msie > 0 || trident > 0;
    }
    if (isIE()) {
        const cartSubmitInput = document.createElement('input');
        cartSubmitInput.setAttribute('name', 'checkout');
        cartSubmitInput.setAttribute('type', 'hidden');
        document.querySelector('#cart').appendChild(cartSubmitInput);
        cartSubmitBtn.addEventListener('click', function(event) {
            document.querySelector('#cart').submit();
        });
    }

    // ---- FIX: this Swiper lives inside the cart drawer, which is hidden
    // on initial load. No need to initialize it until the drawer is
    // actually opened — saves CPU work on every single page load.
    // var cartGridSwiperInitialized = false;
    // function initCartGridSwiper() {
    //     if (cartGridSwiperInitialized) return;
    //     if (!document.querySelector('.custom_cart_grid-slider')) return;
    //     cartGridSwiperInitialized = true;
    //     new Swiper('.custom_cart_grid-slider', {
    //         loop: false,
    //         slidesPerView: 3,
    //         spaceBetween: 2.5,
    //         paginationClickable: true,
    //         breakpoints: {
    //             1920: {
    //                 slidesPerView: 3,
    //                 spaceBetween: 2.5
    //             },
    //             1024: {
    //                 slidesPerView: 3,
    //                 spaceBetween: 2.5
    //             },
    //             0: {
    //                 slidesPerView: 2,
    //                 spaceBetween: 2.5
    //             }
    //         }
    //     });
    // }
    // var cartOpenTriggers = document.querySelectorAll('.header__icon--cart, #cart-icon-bubble, a#cart-icon-bubble');
    // cartOpenTriggers.forEach(function(trigger) {
    //     trigger.addEventListener('click', initCartGridSwiper, { once: false });
    // });
    // Fallback: if cart drawer is ever opened via classList (e.g. from
    // Add to Cart XHR flow below) without a direct click on the icon,
    // this still catches it before the slider would be visually needed.
    // var cartDrawerFallback = document.querySelector('cart-drawer');
    // if (cartDrawerFallback) {
    //     var cartDrawerObserver = new MutationObserver(function(mutations) {
    //         mutations.forEach(function(m) {
    //             if (cartDrawerFallback.classList.contains('active')) {
    //                 initCartGridSwiper();
    //             }
    //         });
    //     });
    //     cartDrawerObserver.observe(cartDrawerFallback, { attributes: true, attributeFilter: ['class'] });
    // }

    var mySwiper = new Swiper('.inner-logos-wrapper.swiper-container', {
        freeMode: false,
        loop: false,
        slidesPerView: 4,
        spaceBetween: 50,
        pagination: {
            el: '.slider__pagination',
            clickable: true,
        },
        breakpoints: {
            1025: {
                slidesPerView: 4,
                spaceBetween: 50
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 50
            },
            320: {
                slidesPerView: 2,
                spaceBetween: 20
            }
        }
    });
    var ColorGroupVarnt = document.querySelectorAll('.shplookprdtinCnt .CustomImage')
    if (ColorGroupVarnt) {
        ColorGroupVarnt.forEach(function(item) {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                document.querySelectorAll('.ColorGroupVrnt').forEach(function(color) {
                    color.classList.remove('active');
                })
                this.querySelector('.ColorGroupVrnt').classList.add('active')
            })
        })
    }

    // ---- FIX: setInterval was pointless here since this whole block
    // already runs inside DOMContentLoaded — the DOM is ready. Calling
    // switcher() directly avoids an unnecessary 1s delay + timer overhead.
    switcher();
    function switcher() {
        if (window.innerWidth < 990) {
            var doublyWrapper = document.querySelector(".doubly-wrapper");
            var mobileLocalizationWrapper = document.querySelector(".mobile-localization-wrapper");
            if (doublyWrapper && mobileLocalizationWrapper) {
                mobileLocalizationWrapper.parentNode.insertBefore(doublyWrapper, mobileLocalizationWrapper.nextSibling);
                doublyWrapper.style.display = "block";
            }
        }
    }

});

document.addEventListener('click', function(event) {
    if (event.target.classList.contains('ViewText')) {
        var cartFooter = document.querySelector('.desktop_subpopu');
        if (cartFooter.classList.contains('Active_Summary')) {
            cartFooter.classList.remove('Active_Summary');
        } else {
            cartFooter.classList.add('Active_Summary');
        }
    }
});

function handleChange(e) {
    if (e.target.closest(".MainVariants .input-label-wrapper input")) {
        var text = '';
        var variantOptions = e.target.closest(".size_option_wrapper-popup").querySelectorAll(".input-label-wrapper input");
        variantOptions.forEach(function(input) {
            if (input.checked) {
                text += input.value + " / ";
            }
        });
        var newname = text.slice(0, -3).trim();
        var productsVariants = e.target.closest(".product_listing_sizes-popup");
        var variant_id;
        var inputs = productsVariants.querySelectorAll("input");
        inputs.forEach(function(input) {
            if (input.checked) {
                var option = productsVariants.querySelector('.hiddenSelector option[variant-title="' + newname + '"]');
                if (option) {
                    variant_id = option.value;
                }
            }
        });
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4 && xhr.status === 200) {

                window.FlexyPeCart.open();
                // var productid = JSON.parse(xhr.responseText);
                // var xhr2 = new XMLHttpRequest();
                // xhr2.open('GET', '/cart');
                // xhr2.onreadystatechange = function() {
                //     if (xhr2.readyState === 4 && xhr2.status === 200) {
                //         var cart = xhr2.responseText;
                //         publish(PUB_SUB_EVENTS.cartUpdate, {
                //             source: 'product-form',
                //             productVariantId: variant_id,
                //             cartData: cart
                //         });
                //         var cartDrawer = document.querySelector('cart-drawer');
                //         if (cartDrawer) {
                //             cartDrawer.classList.add('active');
                //             cartDrawer.classList.remove('is-empty');
                //             var drawerInnerEmpty = document.querySelector('.drawer__inner-empty');
                //             if (drawerInnerEmpty) {
                //                 drawerInnerEmpty.style.display = 'none';
                //             }
                //         }
                //         var headerIconCart = document.querySelector(".header__icon--cart");
                //         var cartHTML = document.createElement('div');
                //         cartHTML.innerHTML = cart;
                //         var cartIconHTML = cartHTML.querySelector('.header__icon--cart').innerHTML;
                //         headerIconCart.innerHTML = cartIconHTML;
                //         var mainDrawerHeading = document.querySelector('.Maindrawer_head .drawer__heading');
                //         var drawerHeading = document.querySelector('h2.drawer__heading');
                //         var extractedHeading = document.createElement('div');
                //         extractedHeading.innerHTML = cart;
                //         var extractedDrawerHeading = extractedHeading.querySelector('h2.drawer__heading');
                //         if (drawerHeading && extractedDrawerHeading) {
                //             drawerHeading.innerHTML = extractedDrawerHeading.innerHTML;
                //         }
                //         var drawerfooter = document.querySelector('.drawer__footer');
                //         var extractedfooter = document.createElement('div');
                //         extractedfooter.innerHTML = cart;
                //         var extractedDrawerfooter = extractedfooter.querySelector('.drawer__footer');
                //         if (drawerfooter && extractedDrawerfooter) {
                //             drawerfooter.innerHTML = extractedDrawerfooter.innerHTML;
                //         }
                //     }
                // };
                // xhr2.send();
            }
        };
        xhr.send(JSON.stringify({
            id: variant_id,
            quantity: 1
        }));

    }
}

// document.addEventListener("click", function(event) {
//     if (event.target.closest(".cart-remove-button svg")) {
//         event.preventDefault();
//         var Obj = event.target.closest(".cart-remove-button").getAttribute("data-variant-id");

//         let updates = {
//             [Obj]: 0
//         };
//         fetch(window.Shopify.routes.root + 'cart/update.js', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({
//                     updates
//                 })
//             })
//             .then(response => {
//                 return response.json();
//             })
//             .then(results => {
//                 var xhr = new XMLHttpRequest();
//                 xhr.open('GET', '/cart', true);
//                 xhr.onreadystatechange = function() {
//                     if (xhr.readyState === 4 && xhr.status === 200) {
//                         var html_get = xhr.responseText;
//                         publish(PUB_SUB_EVENTS.cartUpdate, {
//                             source: 'product-form',
//                             productVariantId: Obj,
//                             cartData: html_get
//                         });
//                         var cartDrawer = document.querySelector('cart-drawer');
//                         if (cartDrawer) {
//                             cartDrawer.classList.add('active');
//                             cartDrawer.classList.remove('is-empty');
//                             var drawerInnerEmpty = document.querySelector('.drawer__inner-empty');
//                             if (drawerInnerEmpty) {
//                                 drawerInnerEmpty.style.display = 'none';
//                             }
//                         }
//                         var headerIconCart = document.querySelector(".header__icon--cart");
//                         var cartHTML = document.createElement('div');
//                         cartHTML.innerHTML = html_get;
//                         var cartIconHTML = cartHTML.querySelector('.header__icon--cart').innerHTML;
//                         headerIconCart.innerHTML = cartIconHTML;
//                         document.querySelector('div#CartDrawer').innerHTML = (new DOMParser().parseFromString(html_get, 'text/html')).querySelector('div#CartDrawer').innerHTML;
//                     }
//                 };
//                 xhr.send();
//             })
//             .catch((error) => {
//                 console.error('Error:', error);
//             });
//     }
// }); 

document.removeEventListener("click", handleChange);
document.addEventListener("click", handleChange);

document.addEventListener('click', function(event) {
    if (event.target.closest('.image_upper_cartbtn .product_upper_cart-trigger svg')) {
        var sizePopupParent = event.target.closest('.size_popup-parent');
        if (sizePopupParent) {
            var productListingSizesPopup = sizePopupParent.querySelector('.product_listing_sizes-popup');
            if (productListingSizesPopup) {
                productListingSizesPopup.classList.add('show_popup');
            }
        } 
    }
});

document.addEventListener('click', function(event) {
    if (event.target.closest('.listing-popup_cross_btn svg')) {
        var sizePopupParent = event.target.closest('.size_popup-parent');
        if (sizePopupParent) {
            var productListingSizesPopup = sizePopupParent.querySelector('.product_listing_sizes-popup');
            if (productListingSizesPopup) {
                productListingSizesPopup.classList.remove('show_popup');
            }
        }
    }
});

var elements = document.querySelectorAll(".first_menu_data");
elements.forEach(function(element) {
    element.addEventListener("click", function() {
        var parentLi = findParentLi(element);
        if (parentLi) {
            var isActive = parentLi.classList.contains("activemonile-menu");
            var mainLiLists = document.querySelectorAll(".has-submenu .mainLiList");
            mainLiLists.forEach(function(mainLiList) {
                mainLiList.classList.remove("activemonile-menu");
            });
            if (!isActive) {
                parentLi.classList.add("activemonile-menu");
            }
        }
    });
});

function findParentLi(element) {
    var parent = element.parentNode;
    while (parent) {
        if (parent.tagName.toLowerCase() === "li") {
            return parent;
        }
        parent = parent.parentNode;
    }
    return null;
}

document.addEventListener("click", function(event) {
    var target = event.target;
    if (target.classList.contains("menu-drawer__menu-item") || target.classList.contains("inner_menu_svg")) {
        var mobileSidebarImagesWrapp = document.querySelectorAll(".mobile-sidebar_images_wrapp");
        mobileSidebarImagesWrapp.forEach(function(element) {
            element.style.display = "none";
        });
    }
    if (target.classList.contains("first_menu_data") || target.classList.contains("custom_top_icon")) {
        var mobileSidebarImagesWrapp = document.querySelectorAll(".mobile-sidebar_images_wrapp");
        mobileSidebarImagesWrapp.forEach(function(element) {
            element.style.display = "none";
        });
        var dataHandle = target.closest("li").getAttribute("data-handle");
        var parentLi = target.closest("li");
        if (parentLi.classList.contains("activemonile-menu")) {
            var mobileSidebarImagesWrappWithDataHandle = document.querySelector(".mobile-sidebar_images_wrapp[data-handle='" + dataHandle + "']");
            if (mobileSidebarImagesWrappWithDataHandle) {
                mobileSidebarImagesWrappWithDataHandle.style.display = "block";
            }
            if (mobileSidebarImagesWrappWithDataHandle && mobileSidebarImagesWrappWithDataHandle.classList.contains("swiper-container-initialized")) {} else {
                new Swiper(".mobile-sidebar_images_wrapp[data-handle='" + dataHandle + "']", {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 10,
                    autoplay: {
                        delay: 5000,
                    }
                });
            }
        } else {
            var mobileSidebarImagesWrappWithDataHandle = document.querySelector(".mobile-sidebar_images_wrapp[data-handle='" + dataHandle + "']");
            if (mobileSidebarImagesWrappWithDataHandle) {
                mobileSidebarImagesWrappWithDataHandle.style.display = "none";
            }
        }
    }
});

var closeButtonElements = document.querySelectorAll(".menu-drawer__close-button");
closeButtonElements.forEach(function(closeButtonElement) {
    closeButtonElement.addEventListener("click", function() {
        setTimeout(function() {
            var dataHandle = document.querySelector("li.mainLiList.activemonile-menu").getAttribute("data-handle");
            document.querySelector(".mobile-sidebar_images_wrapp[data-handle='" + dataHandle + "']").style.display = "block";
        }, 100);
    });
});

document.addEventListener("click", function(event) {
    var target = event.target;
    var crossSvg = document.querySelector(".cross_ccureency-swicher-wrapper .mobile-menu-cross-wrapper svg");
    var crossmain = document.querySelector(".cross_ccureency-swicher-wrapper .mobile-menu-cross-wrapper");
    var menuSummary = document.querySelector(".menu-opening summary");
    if (target === crossSvg || target === crossmain) {
        menuSummary.click();
        setTimeout(function() {
            var dataHandle = document.querySelector("li.mainLiList.activemonile-menu").getAttribute("data-handle");
            document.querySelector(".mobile-sidebar_images_wrapp[data-handle='" + dataHandle + "']").style.display = "block";
        }, 100);
    }
});
 
function validateEmail() {
    var email = document.getElementById("NewsletterForm--email").value;
    var value_length = email.length;
    if (value_length > 0) {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(email)) {
            document.getElementById("emailError").innerText = "";
            document.getElementById("Subscribe").removeAttribute("disabled");
            document.querySelector(".newsletter-form__field-wrapper").classList.remove("show_error_msg");
        } else {
            document.querySelector(".newsletter-form__field-wrapper").classList.add("show_error_msg");
            document.getElementById("emailError").innerText = "*Please include an @ in the email address";
            document.getElementById("Subscribe").setAttribute("disabled", "disabled");
        }
    } else {
        document.getElementById("emailError").innerText = "";
        document.getElementById("Subscribe").removeAttribute("disabled");
        document.querySelector(".newsletter-form__field-wrapper").classList.remove("show_error_msg");
    }
}

// document.addEventListener("mouseup", function(e) {
//     var drawerInner = document.querySelector(".drawer__inner");
//     var cartDrawer = document.querySelector("cart-drawer.drawer");
//     if (!drawerInner.contains(e.target)) {
//         cartDrawer.classList.remove("active");
//     }
// });

var headings = document.querySelectorAll(".footer-block--menu .footer-block__heading");
headings.forEach(function(heading) {
    heading.addEventListener("click", function() {
        this.parentNode.classList.toggle("active_acco");
    });
});
 
document.addEventListener("click", function(event) {
    var target = event.target;
    var wishlist_icon_man = document.querySelectorAll('.wishlist-hero-custom-button.wishlisthero-floating button svg');
    wishlist_icon_man.forEach(function(wishlist) {
        setTimeout(function() {
            var wishlist_item_count = window.WishListHero_SDK.GetWishListItemsCount();
            var wishlist_items_count_element = document.querySelector(".wishlist-hero-items-count");
            if (wishlist_item_count > 0) {
                wishlist_items_count_element.style.display = "block";
            } else {
                wishlist_items_count_element.style.display = "none";
            }
            wishlist_items_count_element.innerHTML = wishlist_item_count;
        }, 1200);
    });
});

document.addEventListener("click", function(event) {
    var cartOverlay = document.querySelector("div#CartDrawer-Overlay");
    var body = document.querySelector("body");
    if (event.target === cartOverlay) {
        body.classList.remove("overflow-hidden");
    }
});
// NOTE: removed the duplicate copy of this exact same listener that was
// registered twice in the original file — it was firing this logic
// two times on every click for no reason.

window.addEventListener('resize', function() {
    if (window.innerWidth < 990) {
        var doublyWrapper = document.querySelector(".doubly-wrapper");
        var mobileLocalizationWrapper = document.querySelector(".mobile-localization-wrapper");
        if (doublyWrapper && mobileLocalizationWrapper) {
            mobileLocalizationWrapper.parentNode.insertBefore(doublyWrapper, mobileLocalizationWrapper.nextSibling);
        }
    } else {
        var doublyWrapper = document.querySelector(".doubly-wrapper");
        var cartIconBubble = document.querySelector("a#cart-icon-bubble");
        if (doublyWrapper && cartIconBubble) {
            cartIconBubble.parentNode.insertBefore(doublyWrapper, cartIconBubble.nextSibling);
        }
    }
});